import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/auth.guard.service';
import { PageNotFoundComponent } from './page.not.found.component';


const appRoutes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home', canActivate: [AuthGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    runGuardsAndResolvers: 'always', data: { screens: ['landingpage'] }
  },
  {
    path: 'user', canActivate: [AuthGuard],
    loadChildren: () => import('./user/user.module').then(m => m.UserModule),
    runGuardsAndResolvers: 'always', data: { screens: ['userlist', 'userdetail'] }
  },
  {
    path: 'organizationdetail', canActivate: [AuthGuard],
    loadChildren: () => import('./organizationdetail/organizationdetail.module').then(m => m.OrganizationDetailModule),
    runGuardsAndResolvers: 'always', data: { screens: ['userlist', 'userdetail'] }
  },
  {
    path: 'invoice', canActivate: [AuthGuard],
    loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoiceModule),
    runGuardsAndResolvers: 'always', data: { screens: ['Invoice', 'InvoiceDetail'] }
  },
  {
    path: 'generalledger', canActivate: [AuthGuard],
    loadChildren: () => import('./generalLedger/general.ledger.module').then(m => m.GeneralLedgerModule),
    runGuardsAndResolvers: 'always', data: { screens: ['generalledgerlist', 'generalledgerdetail'] }
  },
  {
    path: 'currency', canActivate: [AuthGuard],
    loadChildren: () => import('./currency/currency.module').then(m => m.CurrencyModule),
    runGuardsAndResolvers: 'always', data: { screens: ['currencylist', 'currencydetails'] }
  },
  {
    path: 'currencyexchangerate', canActivate: [AuthGuard],
    loadChildren: () => import('./currencyexchangerate/currencyexchangerate.module').then(m => m.CurrencyexchangerateModule),
    runGuardsAndResolvers: 'always', data: { screens: ['currencyexchangeratelist', 'currencyexchangedetail'] }
  },
  {
    path: 'accountstatement',
    loadChildren: () => import('./accountStatement/account.statement.module').then(m => m.AccountStatementModule),

  },
    {
    path: 'accountstatementall',
    loadChildren: () => import('./accountStatementAll/account.statement.all.module').then(m => m.AccountStatementAllModule),

  },
  
  {
    path: "userbranchrole",
    loadChildren: () =>
      import("./userRole/user.role.module").then(
        (m) => m.UserRoleModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["userbranchrole"] },
  },
  {
    path: 'changebranch',
    loadChildren: () => import('./branch/branch.module').then(m => m.BranchModule),
    runGuardsAndResolvers: 'always', data: { screens: ['ChangeBranch'] }
  },
  {
    path: 'loaninterest', canActivate: [AuthGuard],
    loadChildren: () => import('./loanInterest/loan.interest.module').then(m => m.LoanInterestModule),
    runGuardsAndResolvers: 'always', data: { screens: ['loaninterestlist', 'loaninterestdetail'] }
  },
  {
    path: "banktenant",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./banktenant/banktenant.module").then(
        (m) => m.banktenantComponentModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ['banktenantlist', 'banktenantdetails'] },
  },
  {
    path: 'specialloanauthorisation',
    loadChildren: () => import('./specialLoanAuthorisation/special.loan.authorisation.module').then(m => m.SpecialLoanAuthorisationModule),
    runGuardsAndResolvers: 'always', data: { screens: ['specialloanauthorisation'] }
  },
  {
    path: "union",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./Union/union.module").then(
        (m) => m.unionComponentModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ['unionlist', 'uniondetails'] },
  },
  {
    path: 'uniondetail', canActivate: [AuthGuard],
    loadChildren: () => import('./unionDetails/union.module').then(m => m.UnionModule),
    runGuardsAndResolvers: 'always', data: { screens: ['unionlistss', 'uniondetailss'] }
  },
  {
    path: 'loanscheme', canActivate: [AuthGuard],
    loadChildren: () => import('./loanScheme/loan.scheme.module').then(m => m.LoanSchemeModule),
    runGuardsAndResolvers: 'always', data: { screens: ['loanschemelist', 'loanschemedetail'] }
  },

     {
    path: 'standinginstruction',
    loadChildren: () => import('./standinginstruction/standinginstruction.module').then(m => m.StandingInstructionModule),
    runGuardsAndResolvers: 'always', data: { screens: ['standinginstructionlist', 'standinginstructiondetail'] }
  },
  {
    path: 'customer', canActivate: [AuthGuard],
    loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
    runGuardsAndResolvers: 'always', data: { screens: ['customerlist', 'customerdetail'] }
  },
  {
    path: 'datasecurity', canActivate: [AuthGuard],
    loadChildren: () => import('./dataSecurity/data.security.module').then(m => m.DataSecurityModule),
    runGuardsAndResolvers: 'always', data: {
      screens: ["DataSecurityList"
        , "DataSecurityDetail"
      ]
    }
  },

  {
  path: 'collateral', canActivate: [AuthGuard],
  loadChildren: () => import('./collateral/collateral.module').then(m => m.CollateralModule),
  runGuardsAndResolvers: 'always', data: { screens: ['CollateralsList', 'CollateralsDetail'] }
},
{
  path: 'collateralloanallocation', canActivate: [AuthGuard],
  loadChildren: () => import('./collateralLoanapplication/collateralLoanapplication.module').then(m => m.CollateralloanapplicationModule),
  runGuardsAndResolvers: 'always', data: { screens: ['CollateralLoanAllocationsList', 'CollateralLoanAllocationsDetail'] }
  },

  {
  path: 'collateraltype', canActivate: [AuthGuard],
  loadChildren: () => import('./collateralType/collateral.type.module').then(m => m.CollateralTypeModule),
  runGuardsAndResolvers: 'always',
  data: { screens: ['CollateralTypeList', 'CollateralTypeDetail'] }
  },
  {
    path: 'archyai',
    loadChildren: () => import('./archyai/archyai.module').then(m => m.ArchyaiModule),
    runGuardsAndResolvers: 'always', 
    data: { screens: ['ArchiveList', 'ArchiveDetail'] } 
  },

  {
    path: 'consenttype', canActivate: [AuthGuard],
    loadChildren: () => import('./consentType/consent.type.module').then(m => m.ConsentTypeModule),
    runGuardsAndResolvers: 'always', data: { screens: ['ConsentTypeList', 'ConsentTypeDetail'] }
  },
  {
    path: 'customerconsent', canActivate: [AuthGuard],
    loadChildren: () => import('./customerConsent/customer.consent.module').then(m => m.CustomerConsentModule),
    runGuardsAndResolvers: 'always', data: { screens: ['CustomerConsentList', 'CustomerConsentDetail'] }
  },

  {
    path: 'loanproduct', canActivate: [AuthGuard],
    loadChildren: () => import('./loanProduct/loan.product.module').then(m => m.LoanProductModule),
    runGuardsAndResolvers: 'always', data: { screens: ['loanproductlist', 'loanproductdetail'] }
  },
  {
    path: 'loanaccount', canActivate: [AuthGuard],
    loadChildren: () => import('./loanAccount/loan.account.module').then(m => m.LoanAccountModule),
    runGuardsAndResolvers: 'always', data: {
      screens: [
        'loanaccountlist',
        'loanaccountdetail',
        'loanaccountdue',
        'quickloanaccount',
        'loanaccountcharges',

        // 'interfacereq',
        // 'loantransfer'
      ]
    }
  },
  {
    path: 'sharescheme', canActivate: [AuthGuard],
    loadChildren: () => import('./shareScheme/share.scheme.module').then(m => m.ShareSchemeModule),
    runGuardsAndResolvers: 'always', data: { screens: ['shareschemelist', 'shareschemedetail'] }
  },

  {
    path: 'shareaccount', canActivate: [AuthGuard],
    loadChildren: () => import('./shareAccount/share.account.module').then(m => m.ShareAccountModule),
    runGuardsAndResolvers: 'always', data: { screens: ['shareaccountlist', 'shareaccountdetail'] }
  },
  {
    path: 'casascheme', canActivate: [AuthGuard],
    loadChildren: () => import('./casaScheme/casa.scheme.module').then(m => m.CasaSchemeModule),
    runGuardsAndResolvers: 'always', data: { screens: ['casaschemelist', 'casaschemedetail'] }
  },
  {
    path: 'casaaccount', canActivate: [AuthGuard],
    loadChildren: () => import('./casaAccount/casa.account.module').then(m => m.CasaAccountModule),
    runGuardsAndResolvers: 'always', data: { screens: ['casaaccountlist', 'casaaccountdetail'] }
  },
  {
    path: 'termdepositscheme', canActivate: [AuthGuard],
    loadChildren: () => import('./termDepositScheme/term.deposit.scheme.module').then(m => m.TermDepositSchemeModule),
    runGuardsAndResolvers: 'always', data: { screens: ['termdepositschemelist', 'termdepositschemedetail'] }
  },
  {
    path: 'termdepositinterest', canActivate: [AuthGuard],
    loadChildren: () => import('./termDepositInterest/term.deposit.interest.module').then(m => m.TermDepositInterestModule),
    runGuardsAndResolvers: 'always', data: { screens: ['termdepositinterestlist', 'termdepositinterestdetail'] }
  },
  {
    path: 'termdepositaccount', canActivate: [AuthGuard],
    loadChildren: () => import('./termDepositAccount/term.deposit.account.module').then(m => m.TermDepositAccountModule),
    runGuardsAndResolvers: 'always', data: {
      screens: [
        'termdepositaccountlist',
        'termdepositaccountdetail',
      ]
    }
  },
  {
    path: 'tdsrate', canActivate: [AuthGuard],
    loadChildren: () => import('./tdsRate/tds.rate.module').then(m => m.TdsRateModule),
    runGuardsAndResolvers: 'always', data: { screens: ['tdsratelist', 'tdsratedetail'] }
  },
  {
    path: 'overdraftscheme', canActivate: [AuthGuard],
    loadChildren: () => import('./overdraftScheme/overdraft.scheme.module').then(m => m.OverdraftSchemeModule),
    runGuardsAndResolvers: 'always', data: { screens: ['overdraftschemelist', 'overdraftschemedetail'] }
  },
  {
    path: 'overdraftaccount', canActivate: [AuthGuard],
    loadChildren: () => import('./overdraftAccount/overdraft.account.module').then(m => m.OverdraftAccountModule),
    runGuardsAndResolvers: 'always', data: { screens: ['overdraftaccountlist', 'overdraftaccountdetail'] }
  },
  {
    path: 'clearingscheme', canActivate: [AuthGuard],
    loadChildren: () => import('./clearingScheme/clearing.scheme.module').then(m => m.ClearingSchemeModule),
    runGuardsAndResolvers: 'always', data: { screens: ['clearingschemelist', 'clearingschemedetail'] }
  },
  {
    path: 'commissioninterest', canActivate: [AuthGuard],
    loadChildren: () => import('./commissionInterest/commision.interest.module').then(m => m.CommisionInterestModule),
    runGuardsAndResolvers: 'always', data: { screens: ['commissioninterestlist', 'commissioninterestdetail'] }
  },
  {
    path: 'pigmyscheme', canActivate: [AuthGuard],
    loadChildren: () => import('./pigmyScheme/pigmy.scheme.module').then(m => m.PigmySchemeModule),
    runGuardsAndResolvers: 'always', data: { screens: ['pigmyschemelist', 'pigmyschemedetail'] }
  },
  {
    path: 'pigmyaccount', canActivate: [AuthGuard],
    loadChildren: () => import('./pigmyAccount/pigmy.account.module').then(m => m.PigmyAccountModule),
    runGuardsAndResolvers: 'always', data: { screens: ['pigmyaccountlist', 'pigmyaccountdetail'] }
  },
  {
    path: 'generalledgeraccount', canActivate: [AuthGuard],
    loadChildren: () => import('./generalLedgerAccount/general.ledger.account.module').then(m => m.GeneralLedgerAccountModule),
    runGuardsAndResolvers: 'always', data: { screens: ['generalledgeraccountlist', 'generalledgeraccountdetail'] }
  },
  {
    path: 'appraiser', canActivate: [AuthGuard],
    loadChildren: () => import('./appraiser/appraiser.module').then(m => m.AppraiserModule),
    runGuardsAndResolvers: 'always', data: { screens: ['appraiserlist', 'appraiserdetail'] }
  },
  {
    path: 'recurringdepositscheme', canActivate: [AuthGuard],
    loadChildren: () => import('./recurringDepositScheme/recurring.deposit.scheme.module').then(m => m.RecurringDepositSchemeModule),
    runGuardsAndResolvers: 'always', data: { screens: ['recurringdepositschemelist', 'recurringdepositschemedetail'] }
  },
  {
    path: 'recurringdepositinterest', canActivate: [AuthGuard],
    loadChildren: () => import('./recurringDepositInterest/recurring.deposit.interest.module').then(m => m.RecurringDepositInterestModule),
    runGuardsAndResolvers: 'always', data: { screens: ['recurringdepositinterestlist', 'recurringdepositinterestdetail'] }
  },
  {
    path: 'recurringdepositaccount', canActivate: [AuthGuard],
    loadChildren: () => import('./recurringDepositAccount/recurring.deposit.account.module').then(m => m.RecurringDepositAccountModule),
    runGuardsAndResolvers: 'always', data: { screens: ['recurringdepositaccountlist', 'recurringdepositaccountdetail'] }
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
    runGuardsAndResolvers: 'always', data: {
      screens: [
        'loanaccountstatuswisereport',
        'balancesheetreport',
        'cashscrollreport',
        'transferscrollreport',
        'daybook1report',
        'daybook2report',
        'subdaybookreport',
        'profitandlossreport',
        'schedulereport',
        'schedulewithreceiptsandpaymentsreport',
        'graph',
        'dcbreport',
        'trialbalancereport',
        'previousdaysloanrecoveryreport',
        'loanaccountsduereport'
      ]
    }
  },

  {
    path: 'transactiontype',
    canActivate: [AuthGuard],
    loadChildren: () => import('./transactiontype/transactiontype.module').then(m => m.TransactionTypeModule),
    // runGuardsAndResolvers: 'always', data: { screens: ['appraiserlist', 'appraiserdetail'] }
    runGuardsAndResolvers: 'always', data: { screens: ['TransactionTypeList', 'TransactionTypeDetail'] }
  },

  {
    path: 'sourcechannel',
    canActivate: [AuthGuard],
    loadChildren: () => import('./sourceChannel/source.channel.module').then(m => m.SourceChannelModule),
    // runGuardsAndResolvers: 'always', data: { screens: ['appraiserlist', 'appraiserdetail'] }
    runGuardsAndResolvers: 'always', data: { screens: ['EwalletSourceChannelList', 'EwalletSourceChannelDetail'] }
  },

  {
    path: "transactioncodewisecharges",

    loadChildren: () =>
      import("./transactionCodewiseCharges/transactioncodewise.charges.module").then(
        (m) => m.TransactionCodewiseChargesModule
      ),
    runGuardsAndResolvers: "always",
    // data: { screens: ["transactioncodewisechargeslist", "transactioncodewisechargesdetails"] },
    data: { screens: ["TransactionCodeWiseChargesList", "TransactionCodeWiseChargesDetails"] },

  },
  {
    path: 'ewalletrestriction',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./ewalletRestriction/ewallet.restriction.module').then(
        m => m.EwalletRestrictionModule
      ),
    runGuardsAndResolvers: 'always',
    data: { screens: ['EwalletRestrictionList', 'EwalletRestriction'] },
  },

  {
    path: 'accountclassrestrictions', canActivate: [AuthGuard],
    loadChildren: () => import('./accountClassRestriction/accountclass.restriction.module').then(m => m.AccountClassRestrictionModule),
    //  runGuardsAndResolvers: 'always', data: { screens: ['appraiserlist', 'appraiserdetail'] }
    runGuardsAndResolvers: 'always', data: { screens: ['AccountClassRestrictionList', 'AccountClassRestrictionDetail'] }
  },

  {
    path: 'interfaceaccountcharges',
    loadChildren: () => import('./internalFundTransfer/internal.fund.transfer.module').then(m => m.InternalFundTransferModule),
    // runGuardsAndResolvers: 'always', data: { screens: ['internalfundtransferlist', 'interfaceaccountchargesdetail'] }
    runGuardsAndResolvers: 'always', data: { screens: ['InterfaceAccountChargesList', 'InterfaceAccountChargesDetail'] }
  },
  {
    path: 'bank',
    loadChildren: () => import('./bank/bank.module').then(m => m.BankModule),
    runGuardsAndResolvers: 'always', data: { screens: ['branchlist', 'branchdetail'] }
  },

  // {
  //   path: 'branch', canActivate: [AuthGuard],
  //   loadChildren: () => import('./branch/branch.module').then(m => m.BranchModule),
  //   runGuardsAndResolvers: 'always', data: { screens: ['userreport', 'loanaccountstatuswisereport'] }
  // },
  // {
  //   path: 'branch',
  //   loadChildren: () => import('./branch/branch.module').then(m => m.BranchModule),
  //   runGuardsAndResolvers: 'always', data: { screens: ['branchlist', 'branchdetail'] }
  // },


  {
    path: 'branch',
    loadChildren: () => import('./branch/branch.module').then(m => m.BranchModule),
    runGuardsAndResolvers: 'always', data: { screens: ['branchlist', 'BranchMasterDetails'] }
  },
  {
    path: 'passwordpolicy', canActivate: [AuthGuard],
    loadChildren: () => import('./passwordPolicy/password.policy.module').then(m => m.PasswordPolicyModule),
    runGuardsAndResolvers: 'always', data: { screens: ['PasswordPolicyList', 'PasswordPolicyDetail'] }
  },
  {
    path: 'microfinancecenter',
    loadChildren: () => import('./microFinanceCenter/micro.finance.center.module').then(m => m.MicroFinanceCenterModule),
    runGuardsAndResolvers: 'always', data: { screens: ['microfinancecenterlist', 'microfinancecenterdetail'] }
  },

  {
    path: 'grouploanmicrofinance',
    loadChildren: () => import('./groupLoanMicroFinance/group.loan.micro.finance.module').then(m => m.GroupLoanMicroFinanceModule),
    runGuardsAndResolvers: 'always', 
    data: { screens: ['GroupLoanMicroFinanceList', 'GroupLoanMicroFinanceDetails'] } 
  },

  {
    path: "financialDashboard",
    loadChildren: () =>
      import("./financialDashboard/dashboard.financial.module").then(
        (m) => m.DashboardFinancialModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["financialDashboard"] },
  },
  {
    path: 'banknpaparameter',
    loadChildren: () => import('./bankNpaParameter/bank.npa.parameter.module').then(m => m.BankNpaParameterModule),
    runGuardsAndResolvers: 'always', data: { screens: ['banknpaparameterlist', 'banknpaparameterdetail'] }
  },
  {
    path: 'productlevelnpa',
    loadChildren: () => import('./productLevelNpa/product.level.npa.module').then(m => m.ProductLevelNpaModule),
    runGuardsAndResolvers: 'always', data: { screens: ['productlevelnpalist', 'productlevelnpadetail'] }
  },
  {
    path: 'externalbranch',
    loadChildren: () => import('./externalBranch/external.branch.module').then(m => m.ExternalBranchModule),
    runGuardsAndResolvers: 'always', data: { screens: ['externalbranchdetail'] }
  },
  {
    path: 'batch', canActivate: [AuthGuard],
    loadChildren: () => import('./batch/batch.module').then(m => m.BatchModule),
    runGuardsAndResolvers: 'always', data: { screens: ['createbatch'] }
  },
  {
    path: 'clearing', canActivate: [AuthGuard],
    loadChildren: () => import('./clearing/clearing.module').then(m => m.ClearingModule),
    runGuardsAndResolvers: 'always', data: { screens: ['loanrepaymentcheque', 'outwarddataentry', 'outwardreconciliation'] }
  },
  {
    path: 'mpesa', canActivate: [AuthGuard],
    loadChildren: () => import('./mpesa/mpesa.module').then(m => m.MpesaModule),
    runGuardsAndResolvers: 'always', data: { screens: ['mpesalist'] }
  },
  {
    path: 'authorisation',
    loadChildren: () => import('./authorisation/authorisation.module').then(m => m.AuthorisationModule)
  },
  {
    path: 'transaction',
    loadChildren: () => import('./transaction/transaction.module').then(m => m.TransactionModule)
  },
  {
    path: 'provisionpayment', canActivate: [AuthGuard],
    loadChildren: () => import('./yearEndProcess/provision.module').then(m => m.ProvisionModule),
    runGuardsAndResolvers: 'always', data: { screens: ['provisionpayment'] }
  },
   {
    path: "chequebook",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./chequebook/chequebook.module").then((m) => m.ChequebookModule),
    runGuardsAndResolvers: "always",
    data: { screens: ["microfinancecenterlist", "microfinancecenterdetail"] },
  },

  {
    path: "holidayparameter",
    loadChildren: () =>
      import("./calendarEvent/calendar.event.module").then(
        (m) => m.CalendarEventModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["holidayparameter"] },
  },
  {
    path: 'cashiergl', canActivate: [AuthGuard],
    loadChildren: () => import('./cashierGlMaintenance/cashier.gl.maintenance.module').then(m => m.CashierGlMaintenanceModule),
    runGuardsAndResolvers: 'always', data: { screens: ['cashiercashgllist', 'cashiercashgldetail'] }
  },

  {
    path: "deletetransaction",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./deleteTransaction/delete.transaction.module").then(
        (m) => m.DeleteTransactionModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["deletetransaction"] },
  },
  // {
  //   path: "upload",
  // canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import("./upload/upload.module").then(
  //       (m) => m.UploadComponentModule
  //     ),
  //   runGuardsAndResolvers: "always",
  //   data: { screens: ["upload"] },
  // },


  // {
  //   path: "upload",
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import("./upload/upload.module").then(
  //       (m) => m.uploadComponentModule
  //     ),
  //   runGuardsAndResolvers: "always",
  //   data: { screens: ["upload"] },
  // },

  {
    path: "dataupload",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./dataupload/dataupload.module").then(
        (m) => m.dataUploadComponentModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["dataupload"] },
  },
  {
    path: "balancemismatch",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./balanceMismatch/balanceMismatch.module").then(
        (m) => m.BalanceMismatchModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["dataupload"] },
  },
  {
    path: "transactionupload",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./transactionupload/transactionupload.module").then(
        (m) => m.transactionuploadComponentModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["transactionupload"] },
  },
  {
    path: "ssbtransactionupload",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./ssbtransactionupload/ssbtransactionupload.module").then(
        (m) => m.ssbtransactionuploadComponentModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["ssbtransactionupload"] },
  },

  {
    path: 'sharedividend', canActivate: [AuthGuard],
    loadChildren: () => import('./shareDividend/share.dividend.module').then(m => m.ShareDividendModule),
    runGuardsAndResolvers: 'always', data: { screens: ['sharedividend'] }
  },
  {
    path: "deleteaccounts",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./deleteAccounting/delete.accounting.module").then(
        (m) => m.DeleteAccountingModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["deleteaccounts"] },
  },


  {
    path: "screen",
    loadChildren: () =>
      import("./screen/screen.module").then((m) => m.ScreenModule),
    runGuardsAndResolvers: "always",
    data: { screens: ["screen"] },
  },
  {
    path: 'company', canActivate: [AuthGuard],
    loadChildren: () => import('./company/company.module').then(m => m.CompanyModule),
    runGuardsAndResolvers: 'always', data: { screens: ['customerlist', 'customerdetail'] }
  },
  {
    path: "rolescreenlist",
    loadChildren: () =>
      import("./role-screen/role-screen.module").then(
        (m) => m.RoleScreenModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["rolescreenlist"] },
  },
  {
    path: "role",
    loadChildren: () => import("./role/role.module").then((m) => m.RoleModule),
    runGuardsAndResolvers: "always",
    data: { screens: ["role"] },
  },

  {
    path: "reportgroup",
    loadChildren: () =>
      import("./group/group.module").then(
        (m) => m.GroupModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["reportgroup"] },
  },
  {
    path: "reportsubgroup",
    loadChildren: () =>
      import("./subgroup/subgroup.module").then(
        (m) => m.SubgroupModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["reportsubgroup"] },
  },
  {
    path: "assigngluubgroup",
    loadChildren: () =>
      import("./glsubgroup/glsubgroup.module").then(
        (m) => m.GlsubgroupModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["assigngluubgroup"] },
  },

  {
    path: "reportdefinition",
    loadChildren: () =>
      import("./report-definition/report-definition.module").then(
        (m) => m.ReportDefinitionModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["reportdefinition"] },
  },
  {
    path: "reportmaster",
    loadChildren: () =>
      import("./reportmaster/reportmaster.module").then(
        (m) => m.ReportmasterModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["reportmaster",] },
  },
  {
    path: "reportclassification",
    loadChildren: () =>
      import("./classification/classification.module").then(
        (m) => m.ClassificationModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["reportclassification"] },
  },

  {
    path: "charge",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./charge/charge.module").then(
        (m) => m.ChargeModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["chargeList", "chargeDetail"] },
  },
{
  path: "casa-charge",
  canActivate: [AuthGuard],
  loadChildren: () =>
    import("./casa-charge/casa.charge.module").then(
      (m) => m.CasaChargeModule
    ),
  runGuardsAndResolvers: "always",
  data: { screens: ["CasaChargeList", "CasaChargeDetail"] },
},

{
    path: "paynow",
    loadChildren: () =>
      import("./paynow/pay.now.module").then(
        (m) => m.PaynowModule
      ),
  },
  
  {
    path: 'eodlist',
    loadChildren: () => import('./eoddetails/eoddetails.module').then(m => m.EoddetailsModule),
    runGuardsAndResolvers: 'always', data: { screens: ['eodlist'] }
  },
  {
    path: "deleteupload",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./deleteupload/delete.upload.module").then(
        (m) => m.DeleteUploadComponentModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["deleteupload"] },
  },



  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },

 {
    path: "customerfeedback",
    loadChildren: () =>
      import("./customerFeedback/customer.feedback.module").then(
        (m) => m.CustomerFeedbackModule
      ),
  },
   {
    path: "userbranchchange",
    loadChildren: () =>
      import("./userBranchRole/user.branchrole.module").then(
        (m) => m.UserBranchRoleModule
      ),
    runGuardsAndResolvers: "always",
    data: { screens: ["userbranchchangedetail"] },
  },
  //  {
  //   path: 'datasecurity', canActivate: [AuthGuard],
  //   loadChildren: () => import('./dataSecurity/data.security.module').then(m => m.DataSecurityModule),
  //   runGuardsAndResolvers: 'always', data: {
  //     screens: ["DataSecurityList"
  //       , "DataSecurityDetail"
  //     ]
  //   }
  // },
  
  // {
  // path: 'standinginstruction',  // No hyphen, no forward slashes
  // loadChildren: () => import('./standinginstruction/standinginstruction.module').then(m => m.StandingInstructionModule)
  // },

 
  {
    path: '**',
    component: PageNotFoundComponent
  },
  // {
  //   path: 'accountstatus' ,
  //   loadChildren: () => import('./accountStatus/account.status.module').then(m => m.AccountStatusModule),
  //  runGuardsAndResolvers: 'always', data: { screens: ['accountstatus'] }
  // },
  // {
  //   path: 'charge', //canActivate: [AuthGuard],
  //   loadChildren: () => import('./charge/charge.module').then(m => m.ChargeModule),
  //   runGuardsAndResolvers: 'always', data: {
  //     screens: ['chargeList', 'chargeDetail']
  //   }
  // },

];



@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRouteModule { }
